export default __webpack_public_path__ + "static/media/hunter.3702fc76.jpg";